import {atom} from 'jotai'

import {ReferralProgram} from '../domain'

export const ProgramDetailAtom = atom<ReferralProgram | null>(null)
